var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank"},[_c('Step',{attrs:{"arr":_vm.stepProcess}}),_c('Bar',{attrs:{"text":_vm.$route.meta.name}}),_c('div',{staticClass:"bank-form"},[_c('keep-alive',[_c('router-view',{ref:"cForm"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }